var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prolb"},[_c('Headpro'),_c('Selected',{attrs:{"selected":_vm.selected}}),_c('Xmlist',{attrs:{"list":_vm.list}}),_c('Bottom_comp'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }